import {Setting} from "./Setting";

export const politicsSetting: Setting = {
    key: "Politics",
    title: "Политика",
    description: `Политика определяет властные структуры, отношения между фракциями, правителями, народами и классами, а также способы принятия решений, управления территориями и ресурсов. Политическая система часто является движущей силой в развитии сюжета, определяя, кто владеет властью и как ею распоряжается. Политическая ситуация может быть причиной конфликтов, интриг и революций в игровом мире.`,
    components: [
        {
            title: "Властные структуры",
            subComponents: [
                {
                    title: "Монархия",
                    description: `Власть сосредоточена в руках одного правителя, такого как король, император или диктатор. В некоторых случаях могут существовать наследственные династии или выборные монархи.`,
                    examples: ["Королевство, где правит король и его родственники."]
                },
                {
                    title: "Демократия",
                    description: `Власть разделена между народом, представителями или избранными лидерами (например, президентами или конгрессами).`,
                    examples: ["Республика, где народ избирает своих представителей."]
                },
                {
                    title: "Олигархия",
                    description: `Власть сосредоточена в руках небольшой группы людей, часто из-за их богатства, влияния или военной силы.`,
                    examples: ["Город-государство, контролируемый торговыми магнатами."]
                },
                {
                    title: "Тирания",
                    description: `Власть принадлежит жестокому и деспотичному правителю, который использует силу и манипуляции для удержания контроля.`,
                    examples: ["Диктатор, управляющий страной с железной рукой."]
                },
                {
                    title: "Республиканская система",
                    description: `Установлены республики, где власть разделена между исполнительной, законодательной и судебной ветвями власти.`,
                    examples: ["Федерация, где разные регионы имеют свои правительства."]
                },
                {
                    title: "Феодализм",
                    description: `Власть принадлежит землевладельцам и дворянам, которые правят своими землями, а крестьяне или подданные обязаны им служить.`,
                    examples: ["Феодальное королевство, где дворяне владеют землей."]
                },
                {
                    title: "Анархия",
                    description: `Отсутствие централизованной власти, где правила и порядок отсутствуют или нарушены.`,
                    examples: ["Зона, контролируемая бандитами и разными группировками."]
                },
                {
                    title: "Микроструктуры",
                    description: `Города, деревни, гильдии, кланы или другие малые общины могут иметь свои собственные правила и лидеров.`,
                    examples: ["Город-государство, где правит мэр."]
                }
            ]
        },
        {
            title: "Политические фракции",
            subComponents: [
                {
                    title: "Религиозные ордены",
                    description: `Организации, которые контролируют религиозную власть и вмешиваются в политику. Они могут оказывать влияние на общественные нормы, культуру и законы.`,
                    examples: ["Тамплиеры, защищающие святые артефакты."]
                },
                {
                    title: "Торговые гильдии",
                    description: `Группы купцов и предпринимателей, которые имеют влияние на экономику и политику, возможно, манипулируя правительством для получения прибыли.`,
                    examples: ["Гильдия купцов, контролирующая торговлю в городе."]
                },
                {
                    title: "Военные союзы",
                    description: `Группы армий или военачальников, которые контролируют регионы и могут захватывать территории или проводить военные операции.`,
                    examples: ["Альянс королевств для обороны от внешних угроз."]
                },
                {
                    title: "Революционные и повстанческие движения",
                    description: `Фракции, стремящиеся свергнуть существующую власть и изменить политическую систему.`,
                    examples: ["Партизаны, борющиеся за свободу и равенство."]
                },
                {
                    title: "Магические организации",
                    description: `Орден магов или тайные общества, использующие магию для манипулирования политическими решениями.`,
                    examples: ["Коллегия магов, защищающая древние тайны."]
                }]
        },
        {
            title: "Законодательная власть и законы",
            subComponents: [
                {
                    title: "Законодательные органы",
                    description: `Парламенты, ассамблеи или сенаты, которые принимают законы, устанавливают налоги и регулируют ресурсы.`,
                    examples: ["Совет волшебников, управляющий магическими законами."]
                },
                {
                    title: "Законы и правосудие",
                    description: `Законы могут быть написаны, устные или обоснованные магией или богами. Как правило, они устанавливают нормы поведения, управления и наказания.`,
                    examples: ["Закон о запрете магии темного происхождения."]
                },
                {
                    title: "Права граждан",
                    description: `В некоторых мирах граждане могут иметь права на свободу, имущество и защиту от угнетения, в других же такие права могут быть ограничены.`,
                    examples: ["Декларация прав человека, защищающая свободу и равенство."]
                }]
        },
        {
            title: "Международные отношения",
            subComponents: [
                {
                    title: "Дипломатия",
                    description: `Переговоры, альянсы и соглашения между странами или фракциями для установления мирных отношений, торговли или союза против общего врага.`,
                    examples: ["Договор о ненападении между королевствами."]
                },
                {
                    title: "Война и конфликты",
                    description: `Политические отношения могут приводить к военным столкновениям, в том числе защита территорий, расширение границ или борьба за ресурсы.`,
                    examples: ["Война за независимость, конфликт за земли."]
                },
                {
                    title: "Колонизация и захват территорий",
                    description: `Страны могут стремиться к захвату новых земель, колонизации или установлению контроля над важными ресурсами.`,
                    examples: ["Экспансия империй, колонизация диких земель."]
                },
                {
                    title: "Контрабанда и шпионаж",
                    description: ` Политические фракции могут использовать тайных агентов для добычи секретной информации или организации саботажа враждебных правительств.`,
                    examples: ["Тайный агент, работающий на враждебное государство."]
                }]
        },
        {
            title: "Экономические и социальные факторы",
            subComponents: [
                {
                    title: "Коррупция",
                    description: `Правители, чиновники и аристократы могут участвовать в незаконных или аморальных действиях для удержания власти и увеличения богатства.`,
                    examples: ["Коррумпированный министр, принимающий взятки."]
                },
                {
                    title: "Нищета и социальное неравенство",
                    description: `Разделение между богатыми и бедными слоями населения может вызывать социальное напряжение, протесты или революции.`,
                    examples: ["Бунт бедняков против богатых торговцев."]
                },
                {
                    title: "Пропаганда и манипуляции",
                    description: `Политические лидеры могут использовать пропаганду, ложную информацию и контроль над СМИ для манипулирования мнением населения.`,
                    examples: ["Фальшивые новости, распространяемые правительством."]
                }]

        }
    ],
    prompt: {
        component: {
            list: 'Перечисли возможные компоненты политики и опиши их если они применимы к истории. Не ограничивайся основными компонентами если необходимо',
            single: 'Сгенерируй компонент политики для мира. Опиши ключевые аспекты, структуры и последствия политических решений.',
            extend: 'Дополни описание компонента политики и разбей на абзацы. Как компонент влияет на мир и персонажей.'
        },
        element:{
            list: 'Перечисли возможные элементы политики и опиши их если они применимы к истории. Не ограничивайся основными элементами если необходимо',
            single: 'Сгенерируй элемент политики для мира. Опиши ключевые аспекты, структуры и последствия политических решений.',
            extend: 'Дополни описание элемента политики и разбей на абзацы. Как элемент влияет на мир и персонажей.'

        },
        lore:{
            list: "Создай элементы лора на основе этого элемента политики. Его историю, мифы, влияние на мир и персонажей",
            single: "Создай элементы лора на основе этого элемента политики. Опиши что-то одно, например: историю, мифы, влияние на мир и персонажей",
            extend: "Дополни описание элемента лора политики и разбей на абзацы."
        }
    }

}